// @flow
/* eslint-disable import/prefer-default-export */
// $FlowFixMe
import type { UseQueryResult } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { globalQueryClient } from 'queries/queryClient'
import { invalidateLoadQuestions } from 'queries/questions/useLoadQuestions'
import type { Form, FormLabel, FormParams, FormResponse } from 'types/form'

import { QUERIES } from '@/enums/queries'

import {
  getForm,
  getFormLabels,
  getFormsAndDocuments,
} from './services/loadForms'

export const useLoadFormLabels = (
  options: any = {}
  // $FlowFixMe
): UseQueryResult<Array<FormLabel>, Error> => {
  return useQuery({
    queryKey: [QUERIES.FORMS.LIST_LABELS],
    queryFn: () => {
      return getFormLabels()
    },
    ...options,
  })
}

export const useLoadFormsAndDocuments = (
  params: FormParams,
  options: any = {}
  // $FlowFixMe
): UseQueryResult<FormResponse, Error> => {
  return useQuery({
    queryKey: [QUERIES.FORMS.LIST_WITH_DOCUMENTS, params],
    queryFn: ({ signal }) => {
      return getFormsAndDocuments(params, { signal })
    },
    ...options,
  })
}

export const useLoadForm = (
  id: string,
  options: any = {}
  // $FlowFixMe
): UseQueryResult<Form, Error> => {
  return useQuery({
    queryKey: [QUERIES.FORMS.GET, id],
    queryFn: () => {
      return getForm(id)
    },
    ...options,
  })
}

export const invalidateLoadForms = () => {
  globalQueryClient.invalidateQueries({
    queryKey: [QUERIES.FORMS.LIST],
    exact: false,
  })

  globalQueryClient.invalidateQueries({
    queryKey: [QUERIES.FORMS.LIST_LABELS],
    exact: false,
  })

  globalQueryClient.invalidateQueries({
    queryKey: [QUERIES.FORMS.LIST_WITH_DOCUMENTS],
    exact: false,
  })

  globalQueryClient.invalidateQueries({
    queryKey: [QUERIES.FORMS.GET],
    exact: false,
  })

  invalidateLoadQuestions()
}

export const invalidateLoadForm = () => {
  globalQueryClient.invalidateQueries({
    queryKey: [QUERIES.FORMS.GET],
    exact: false,
  })
}
